import * as yup from "yup";
import { Create_Edit_UserFormValidation } from "../../Users/Create_Edit_User/Create_Edit_UserFormValidation";

export const ReservationFormValidation = yup.object().shape({
    idBook: yup
        .string()
        .required('Selecione o livro'),
    idUser: yup
        .string()
        .required("O campo é obrigatório."),
    reservationDate: yup
        .string()
        .required("A Data de Reserva é obrigatória.")
        .test(
            "is-valid-date",
            "A Data de Reserva deve ser válida.",
            (value) => !value || !isNaN(Date.parse(value))
        ),
    startDate: yup
        .string()
        .required("A Data de Início é obrigatória.")
        .test(
            "is-valid-date",
            "A Data de Início deve ser válida.",
            (value) => !value || !isNaN(Date.parse(value))
        )
        .test(
            "is-after-reservation",
            "A Data de Início deve ser igual ou posterior à Data de Reserva.",
            function (value) {
                const { reservationDate } = this.parent;
                return !value || !reservationDate || new Date(value) >= new Date(reservationDate);
            }
        ),
    endDate: yup
        .string()
        .required("A Data de Término é obrigatória.")
        .test(
            "is-valid-date",
            "A Data de Término deve ser válida.",
            (value) => !value || !isNaN(Date.parse(value))
        )
        .test(
            "is-after-start",
            "A Data de Término deve ser igual ou posterior à Data de Início.",
            function (value) {
                const { startDate } = this.parent;
                return !value || !startDate || new Date(value) >= new Date(startDate);
            }
        )
});
